import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-client-dialog',
  templateUrl: './client-dialog.component.html',
  styleUrls: ['./client-dialog.component.scss']
})
export class ClientDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
